import { render, staticRenderFns } from "./BaseChip.vue?vue&type=template&id=97821c94&scoped=true"
import script from "./BaseChip.vue?vue&type=script&lang=js"
export * from "./BaseChip.vue?vue&type=script&lang=js"
import style0 from "./BaseChip.vue?vue&type=style&index=0&id=97821c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97821c94",
  null
  
)

export default component.exports